import React from "react"
import "./CustomBreadCrumb.scss"
import { useNavigate } from "react-router-dom"

const CustomBreadCrumb = ({ data, pageTitle, handleClick }) => {
  const navigate = useNavigate()
  return (
    <div className="pixwik-breadcrumb mt-2 ">
      <h4>{pageTitle}</h4>
      <div className="bread-crumb-items d-flex align-item-center">
        {data.map((item, index) => (
          <span
            key={index}
            onClick={(e) => {
              e.preventDefault()
              handleClick(item.link)
            }}
            className={`breadcrumb-text cursor-pointer text-500 ${
              index === data.length - 1 ? "last-breadcrumb" : ""
            }`}
          >
            {item.label}
            {index !== data.length - 1 && (
              <span className="mx-2 flex align-items-center justify-content-center">
                <i className="pi ion ion-ios-arrow-forward " />
              </span>
            )}
          </span>
        ))}
      </div>
    </div>
  )
}

export default CustomBreadCrumb
